module.exports = __webpack_public_path__ + "static/media/profile-pic.b1f5ff0d.png";